import React from 'react'

export default React.lazy(() => import('./Iso14064Management'))
